import { mapGetters } from 'vuex';
import schoolsTable from '../schoolstable/schools-table.vue';

export default {
  name: 'schoolsDistrict',
  inject: ['$eventBus'],
  props: {
    data: {
        type: Object,
        default: {}
    }
  },
  components: {
     schoolsTable
  },
  computed: {
    ...mapGetters('glb', ['viewport', 'glb'])
  }
};